/*eslint-disable */
import chatInfo from '@/components/workspace/chat-info/';
import chatListSidebar from '@/components/workspace/chat-list-sidebar/';
import toolRightSidebar from '@/components/workspace/workspace-right-sidebar/';
export default {
  name: 'workspace',
  components: {
    'chat-list' : chatListSidebar,
    'chat-info' : chatInfo,
    'tool-right-sidebar' : toolRightSidebar
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


